import { Select } from '@amzn/awsui-components-react-v3';
import React from 'react';
import { REPORT_TYPE } from '../../constants/report_type';
import { AccuracyButtonNewStyle } from '../../styles/common_styles';
import { Currency } from '../const/dropdown_elements';
import {findOption} from "../reports/utils/buttons";

export class CurrencyButton extends React.Component {
  getOptions = () => {
    let options = [];
    for (let currency of Currency) {
      if (this.props.report.toUpperCase() === REPORT_TYPE.BENCHMARK && currency.value !== 'LOCAL') {
        continue;
      }
      if (this.props.excludeLocal && currency.value === 'LOCAL') {
        continue;
      }
      options.push(currency);
    }
    return options;
  }

  render() {
    return (
      <div className={AccuracyButtonNewStyle}>
        <b> {this.props.text} </b>
        <Select
          options={this.getOptions()}
          selectedOption={findOption(this.getOptions(), this.props.selected)}
          placeholder={this.props.text}
          onChange={this.props.onChange}
          data-cy={this.props['data-cy']}
        />
      </div>
    );
  }

  static defaultProps = {
    'data-cy': 'currency-button'
  }
}


// WEBPACK FOOTER //
// ./src/components/buttons/currency_button.jsx